import React from 'react';
import EmptyList from 'src/components/templates/EmptyList.template';
import useI18n from 'src/modules/translations/hooks/useI18n';
const ListEmpty = ({}) => {
    const { translate } = useI18n();
    return (React.createElement(EmptyList, { message: translate('There are no Exam Communities at the moment. Please check again later on.') }));
};
export default React.memo(ListEmpty);
